var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEplFile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14L19 8V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21Z",
    fill: "#0B2133"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8652 15.2801V15.9656H14.7178V15.2801H16.8652ZM15.002 11.7V15.9656H14.123V11.7H15.002Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.157 14.4451H11.0701V13.7596H12.157C12.325 13.7596 12.4617 13.7322 12.5671 13.6775C12.6726 13.6209 12.7498 13.5428 12.7986 13.4432C12.8474 13.3436 12.8718 13.2312 12.8718 13.1062C12.8718 12.9793 12.8474 12.8611 12.7986 12.7518C12.7498 12.6424 12.6726 12.5545 12.5671 12.4881C12.4617 12.4217 12.325 12.3885 12.157 12.3885H11.3748V15.9656H10.4958V11.7H12.157C12.491 11.7 12.7771 11.7605 13.0154 11.8816C13.2556 12.0008 13.4392 12.1658 13.5662 12.3768C13.6931 12.5877 13.7566 12.8289 13.7566 13.1004C13.7566 13.3758 13.6931 13.6141 13.5662 13.8152C13.4392 14.0164 13.2556 14.1717 13.0154 14.2811C12.7771 14.3904 12.491 14.4451 12.157 14.4451Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0432 15.2801V15.9656H7.77271V15.2801H10.0432ZM8.05981 11.7V15.9656H7.18091V11.7H8.05981ZM9.74731 13.4373V14.1053H7.77271V13.4373H9.74731ZM10.0403 11.7V12.3885H7.77271V11.7H10.0403Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19",
    fill: "#596C7C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEplFile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "epl-file.c88e2ef8615180baa0457306776ba741.svg";